import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { ErrorCircleFilled } from "@fluentui/react-icons";
import React from "react";
import { $crimson60 } from "../../../cssjs/colors";

interface IErrorMessageProps {
  errorMsg: string;
  className?: string;
}

const ErrorMessage: React.FC<IErrorMessageProps> = ({
  errorMsg,
  className = "",
}) => {
  const classes = useStyles();
  return (
    <div className={mergeClasses(classes.errorMsg, className)}>
      <ErrorCircleFilled className={classes.icon} aria-label="error-msg" />
      {errorMsg}
    </div>
  );
};

export default ErrorMessage;

const useStyles = makeStyles({
  errorMsg: {
    color: $crimson60,
    fontStyle: "italic",
    padding: "10px",
    fontSize: "14px",
    fontWeight: "500",
    gap: "2px",
  },
  icon: {
    fontSize: "16px !important",
  },
});
